import SimpleSlider from "./SimpleSlider";

const IndustryTalk = () => {
  return (
    <div className="relative bg-night overflow-hidden">
      <div className="glow-orb w-[300px] h-[300px] bg-customRed/10 bottom-0 right-1/4"></div>
      <div className="max-w-[1140px] mx-auto pb-24 pt-10 p-4 relative">
        <h1 className="text-3xl font-bold text-white">
          What the Industry <span className="text-gradient">Talks About Us</span>
        </h1>
        <div className="web3-underline w-[70px] mt-3"></div>
        <SimpleSlider />
      </div>
    </div>
  );
};

export default IndustryTalk;
